module.exports = __webpack_public_path__ + "static/media/icon_10.f3e74c7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_10.png
// module id = 1651
// module chunks = 1